module.exports = __webpack_public_path__ + "08_mole.c14b40e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/08_mole.png
// module id = tA3s
// module chunks = 0